import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { GeneralAlertEmailLog } from 'contracts/AlertEmailLogs';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_ALERT_EMAIL_LOGS_',
  }
);

export interface FetchAlertEmailLogsState {
  data: GeneralAlertEmailLog[];
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchAlertEmailLogsRequestAction {
  id: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: GeneralAlertEmailLog[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchAlertEmailLogsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: FetchAlertEmailLogsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchAlertEmailLogsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchAlertEmailLogsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchAlertEmailLogsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchAlertEmailLogs = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchAlertEmailLogsTypes = Types;
export const FetchAlertEmailLogsActions = Creators;